import request from '@/utils/request'

// 货主列表
export const owner_list = (data) => {
    return request({
        url: '/erp/base-supplier/list',
        method: 'post',
        data
    })
}

// 货主新增
export const owner_create = (data) => {
    return request({
        url: '/erp/base-supplier/create__role',
        method: 'post',
        data
    })
}

// 货主编辑
export const owner_update = (data) => {
    return request({
        url: '/erp/base-supplier/create',
        method: 'post',
        data
    })
}

// 货主详情
export const owner_detail = (data) => {
    return request({
        url: '/erp/base-supplier/detail',
        method: 'post',
        data
    })
}

// 货主详情
export const owner_delete = (data) => {
    return request({
        url: '/erp/base-supplier/delete',
        method: 'post',
        data
    })
}


// 货主编号
export const owner_number = (data) => {
    return request({
        url: '/erp/base-supplier/supplier-sn',
        method: 'post',
        data
    })
}